export const VALUE_SET_SIGNEDBY =
  'http://woundtech.net/fhir/ValueSet/patient-sign-signedby';
export const VALUE_SET_UNABLE_TO_SIGNEDBY =
  'http://woundtech.net/fhir/ValueSet/patient-sign-unable-to-sign';
export const VALUE_SET_HIPPA =
  'http://woundtech.net/fhir/extensions/admission-consent-hippa';
export const VALUE_SET_TREATMENT =
  'http://woundtech.net/fhir/extensions/admission-consent-treatment';
export const VALUE_SET_MEDICAL =
  'http://woundtech.net/fhir/extensions/admission-consent-medical';
export const VALUE_SET_RELEASE_FORM =
  'http://woundtech.net/fhir/extensions/admission-consent-release-form';
export const VALUE_SET_REQUEST_LETTER =
  'http://woundtech.net/fhir/extensions/admission-consent-request-letter';
export const VALUE_SET_PARTNERSHIP_AGREEMENT =
  'http://woundtech.net/fhir/extensions/admission-consent-partnership-form';
export const VALUE_SET_MEDIA_RELEASE =
  'http://woundtech.net/fhir/extensions/admission-consent-media-release';
export const VALUE_SET_ELECTRONIC_COMMUNICATION =
  'http://woundtech.net/fhir/extensions/admission-consent-electronic-communication';
export const VALUE_SET_AI_RECORDING =
  'http://woundtech.net/fhir/extensions/admission-consent-ai-recording';
export const VALUE_SET_AI_SCRIBE_RELEASE =
  'http://woundtech.net/fhir/extensions/admission-consent-ai-scribe-release'; // NOSONAR
export const VALUE_SET_NAME =
  'http://woundtech.net/fhir/extensions/relative-name';
export const VALUE_SET_RELATION =
  'http://woundtech.net/fhir/extensions/relationship-to-patient';
export const VALUE_SET_COPY_PARTNERSHIP_AGREEMENT =
  'http://woundtech.net/fhir/extensions/admission-consent-copy-partnership-agreement';
export const VIEW_ACCEPT = 'I have read and agree to: ';
export const ADMISSION_CONSENT_MEDICAL = 'admission-consent-medical';
export const ADMISSION_CONSENT_HIPPA = 'admission-consent-hippa';
export const ADMISSION_CONSENT_MEDIA_RELEASE =
  'admission-consent-media-release';
export const ADMISSION_CONSENT_TREATMENT = 'admission-consent-treatment';
export const ADMISSION_CONSENT_RELEASE_FORM = 'admission-consent-release-form';
export const ADMISSION_CONSENT_REQUEST_LETTER =
  'admission-consent-request-letter';
export const ADMISSION_CONSENT_PARTNERSHIP_AGREEMENT =
  'admission-consent-partnership-form';
export const ADMISSION_CONSENT_ELECTRONIC_COMMUNICATION =
  'admission-consent-electronic-communication';
export const ADMISSION_CONSENT_AI_RECORDING = 'admission-consent-ai-recording';
export const ADMISSION_CONSENT_AI_SCRIBE_RELEASE =
  'admission-consent-ai-scribe-release';
export const ADMISSION_CONSENT_DESKTOP_DESCRIPTION =
  "Consent forms have not been completed for this patient. You can access the consent forms from the iPad or iPhone to be able to capture the patient's signature.";

export const MAP_ADMISSION_CONSENT_FORMS = {
  [ADMISSION_CONSENT_MEDICAL]: {
    url: VALUE_SET_MEDICAL,
    label: "Woundtech's Notice Of Privacy Practices",
  },
  [ADMISSION_CONSENT_HIPPA]: {
    url: VALUE_SET_HIPPA,
    label: "Woundtech's HIPAA Acknowledgement and Consent Form",
  },
  [ADMISSION_CONSENT_TREATMENT]: {
    url: VALUE_SET_TREATMENT,
    label: "Woundtech's Authorization for Treatment",
  },
  [ADMISSION_CONSENT_RELEASE_FORM]: {
    url: VALUE_SET_RELEASE_FORM,
    label: 'Woundtech HIPAA Release Form',
  },
  [ADMISSION_CONSENT_REQUEST_LETTER]: {
    url: VALUE_SET_REQUEST_LETTER,
    label: 'Woundtech Medical Records Request Letter',
  },
  [ADMISSION_CONSENT_PARTNERSHIP_AGREEMENT]: {
    url: VALUE_SET_PARTNERSHIP_AGREEMENT,
    label: 'Woundtech Partnership Agreement',
  },
  [ADMISSION_CONSENT_AI_RECORDING]: {
    url: VALUE_SET_AI_RECORDING,
    label:
      'Consent for Recording and AI Assisted Documentation of Clinical Visits',
  },
};

export const MAP_ADMISSION_CONSENT_FORMS_YES_NO: {
  [key: string]: { url: string; label: string; documentType?: string };
} = {
  [ADMISSION_CONSENT_MEDIA_RELEASE]: {
    url: VALUE_SET_MEDIA_RELEASE,
    label: "Woundtech's Media Release",
  },
  [ADMISSION_CONSENT_ELECTRONIC_COMMUNICATION]: {
    url: VALUE_SET_ELECTRONIC_COMMUNICATION,
    label: 'Woundtech Electronic Communication',
  },
  [ADMISSION_CONSENT_AI_SCRIBE_RELEASE]: {
    url: VALUE_SET_AI_SCRIBE_RELEASE,
    label: 'Woundtech AI Scribe Release',
    documentType: ADMISSION_CONSENT_AI_RECORDING,
  },
};

export const getAgreeConsentForms = (isWoundScribeEnabled: boolean) => {
  if (isWoundScribeEnabled) {
    return MAP_ADMISSION_CONSENT_FORMS;
  }
  return Object.fromEntries(
    Object.entries(MAP_ADMISSION_CONSENT_FORMS).filter(
      ([formName]) => formName !== ADMISSION_CONSENT_AI_RECORDING
    )
  ) as typeof MAP_ADMISSION_CONSENT_FORMS;
};

export const getYesNoConsentForms = (isWoundScribeEnabled: boolean) => {
  if (isWoundScribeEnabled) {
    return MAP_ADMISSION_CONSENT_FORMS_YES_NO;
  }
  return Object.fromEntries(
    Object.entries(MAP_ADMISSION_CONSENT_FORMS_YES_NO).filter(
      ([formName]) => formName !== ADMISSION_CONSENT_AI_SCRIBE_RELEASE
    )
  ) as typeof MAP_ADMISSION_CONSENT_FORMS_YES_NO;
};

export const getAdmissionConsentValueSet = (isWoundScribeEnabled: boolean) =>
  Object.values(getAgreeConsentForms(isWoundScribeEnabled))
    .map((urlLabel) => urlLabel.url)
    .concat(
      Object.values(getYesNoConsentForms(isWoundScribeEnabled)).map(
        (urlLabel) => urlLabel.url
      )
    );

export const LIST_ADMISSION_CONSENT_VALUESET = getAdmissionConsentValueSet(true);

export const CONSENT_OPTIONS = {
  YES: 'Yes',
  NO: 'No',
};

export const VALUE_SET_ELECTRONIC_COMMUNICATION_CHECK =
  'http://woundtech.net/fhir/extensions/admission-consent-electronic-communication-check'; // NOSONAR

export const WOUNDSCRIBE_PERMISSION_CHECK =
  'http://woundtech.net/fhir/extensions/admission-consent-ai-scribe-release'; // NOSONAR
